import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {UNLEASH_TOGGLES} from '@app/config/FeatureToggleConfig';
import {ConfigService, DcpGlobalMessageService, FeatureTogglesService} from '@dcp/configurator';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector, private configService: ConfigService) {}

  handleError(error: any) {
    this.injector
      .get(FeatureTogglesService)
      .isEnabled(UNLEASH_TOGGLES.globalErrorHandler)
      .pipe(untilDestroyed(this))
      .subscribe((isEnabled) => {
        if (isEnabled && !error?.url?.includes(this.configService.getString('kyma.namespace.log'))) {
          this.injector.get(DcpGlobalMessageService).addMessage(error, this?.constructor?.name, 'errorLogging');
        }
      });
  }
}
